<div class="cont" #cont>
    <ngx-masonry
        [updateLayout]="updateMasonryLayout"
        [useImagesLoaded]="true"
        [options]="options"
        (layoutComplete)="layoutComplete($event)"
        #masonryContainer
    >
        <ngxMasonryItem
            class="masonry-item"
            [style.marginBottom]="options.gutter + 'px'"
            *ngFor="let item of gridItems, let i = index"
        >
            <div class="grid-item-wrapper">

                <img
                    [src]="item.src"
                    (click)="clickHandler(item, i)"
                    [width]="itemWidth"
                />
            </div>
        </ngxMasonryItem>
    </ngx-masonry>
</div>

